module.exports = __webpack_public_path__ + "static/media/bateria.1d7382b5.jpg";